import React, {useEffect, useRef, useState} from "react";
import {Header} from "../../components/Header";
import {Container} from "../../components/Container";
import {API} from "../../api";
import {Block} from "../../components/Block";
import {BlockSide} from "../../components/Block/BlockSide";
import {Button} from "../../components/Button";
import {isMobileDevice} from "../../hooks/mobile/isMobile";

const api = new API();

export function AccountPage({isMobile = isMobileDevice()}) {
    const [isVkLoading, setVkLoading] = useState(false);
    const [isYmLoading, setYmLoading] = useState(false);


    const resetAuth = () => {
        api.vk.resetCredentials();
        window.location.href= "/";
    };

    const resetPlatformToken = (platform) => {
        if (platform === "vk") setVkLoading(true);
        else setYmLoading(true);
        api.resetPlatformToken(platform).finally(() => {
            setYmLoading(false);
            setVkLoading(false);
        });
    };


    return (<div>
            <Header />
            <Container>
                <h1 style={{whiteSpace: 'nowrap', textOverflow: "ellipsis", overflowX: "hidden"}}>Аккаунт</h1>
                <Block smallPadding={isMobile}>
                    <BlockSide style={{display: "flex", flexDirection: "column", gap: "10px", width: isMobile ? "100%" : "40%"}}>
                        <Button size="m" responsive={true} isRich={false} isPrimary={false} isLoading={isVkLoading} onClick={() => resetPlatformToken("vk")}>Сбросить токен Вк Музыки</Button>
                        <Button size="m" responsive={true} isRich={false} isPrimary={false} isLoading={isYmLoading} onClick={() => resetPlatformToken("ym")}>Сбросить токен Яндекс Музыки</Button>
                        <Button size="m" responsive={true} isRich={true} isPrimary={false} onClick={resetAuth}>Выйти из аккаунта</Button>
                    </BlockSide>
                </Block>
            </Container>
        </div>
    )
}
